/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Settings page components
import PageLayout from "examples/LayoutContainers/PageLayout";
import BasicInfo from "./components/BasicInfo";
import { useUploadImage } from "hook/services";
import { useUpdateAgencyConfig } from "queries/configurator";
import timezones from "timezones.json";
import { useAgencyInfo } from "../../../../context/agency";
import { useEffect, useState } from "react";
function Settings() {
  const uploadImage = useUploadImage();
  const [agency, Update] = useAgencyInfo();
  const [timezones_data, settimezones_data] = useState([]);
  const [agency_data, setagency_data] = useState([]);
  const [logo, setlogo] = useState("");
  const [whitelabel_logo, setwhitelabel_logo] = useState("");
  const [chatapp_logo, setChatapp_logo] = useState("");
  const [ghl_connect_logo, setGhl_connect_logo] = useState("");
  const [hero_image, sethero_image] = useState(agency?.Customization?.hero_image || "");
  const [bussiness_name, setbussiness_name] = useState(agency?.profile?.bussiness_name);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState(agency?.Categories || []);
  const [pricing_page_message, setPricingPageMessage] = useState(
    agency?.pricing_page_message || ""
  );
  const [pricing_page_headline, setPricingPageHeadline] = useState(
    agency?.pricing_page_headline || ""
  );
  const [keyBenefits, setKeyBenefits] = useState(agency?.keyBenefits || ["", "", "", "", ""]);
  const [train_your_ai, setTrainYourAI] = useState(agency?.train_your_ai || ["", "", "", "", ""]);
  const [upgrade_benefits, setUpgradeBenefits] = useState(agency?.upgrade_benefits || ["", "", ""]);

  const handleImage = async (file, type) => {
    if (type == "logo") {
      setlogo(file);
    } else if (type == "ghl_connect_logo") {
      setGhl_connect_logo(file);
    } else if (type == "chatapp_logo") {
      setChatapp_logo(file);
    } else if (type == "whitelabel_logo") {
      setwhitelabel_logo(file);
    }
    if (type == "logo") {
      setlogo(file);
    } else {
      sethero_image(file);
    }
  };

  // This payload includes Categories (BrandingTabs/Category.js's "Create
  // Category" flow submits through this same handleSubmit), so a successful
  // save refreshes both the agency doc and the "categories" resource.
  const saveSettingsMutation = useUpdateAgencyConfig(true);

  const handleSubmit = async (e, val) => {
    var newsfeedshow, video_text, video_link;
    if (val?.video_text) {
      video_text = val.video_text;
      video_link = val.video_link;
    } else {
      newsfeedshow = val === true ? true : false;
    }

    let updatedCategories = categories;
    if (val?.id && val?.name) {
      updatedCategories = [...categories, val];
      setCategories(updatedCategories);
    }

    e.preventDefault();
    setLoading(true);
    var hero_bg = null;
    var hero_image_url = null;
    const default_image = e.target?.default_image?.value === "true";
    const custom_color = e.target?.custom_color?.value === "true";
    const domain_update = e.target?.domain_update?.value === "true";

    if (!default_image) {
      if (!custom_color) {
        hero_image_url = hero_image;
      } else {
        hero_bg = e.target.hero_bg.value;
      }
    }
    const customer_info = {
      email:
        e.target.email === undefined
          ? agency?.Customization?.customer_info?.email
          : e.target.email.value,
      name:
        e.target.name.value === undefined
          ? agency?.Customization?.customer_info?.name
          : e.target.name.value,
      phone_number:
        e.target.phone_number === undefined
          ? agency?.Customization?.customer_info?.phone_number
          : e.target.phone_number.value,
    };
    const social_urls = {
      facebook:
        e.target.facebook === undefined
          ? agency?.Customization?.social_urls?.facebook
          : e.target.facebook.value,
      instagram:
        e.target.instagram === undefined
          ? agency?.Customization?.social_urls?.instagram
          : e.target.instagram.value,
      linkedin:
        e.target.linkedin === undefined
          ? agency?.Customization?.social_urls?.linkedin
          : e.target.linkedin.value,
      twitter:
        e.target.twitter === undefined
          ? agency?.Customization?.social_urls?.twitter
          : e.target.twitter.value,
    };
    const customization = {
      topbar_bg:
        e.target.topbar_bg === undefined
          ? agency?.Customization?.topbar_bg
          : e.target.topbar_bg.value,
      topbar_text:
        e.target.topbar_text === undefined
          ? agency?.Customization?.topbar_text
          : e.target.topbar_text.value,
      home_page_title:
        e.target.home_page_title === undefined
          ? agency?.Customization?.home_page_title
          : e.target.home_page_title.value,
      topbar_active_text:
        e.target.topbar_active_text === undefined
          ? agency?.Customization?.topbar_active_text
          : e.target.topbar_active_text.value,
      //   // body_bg: e.target.body_bg.value,
      button_bg:
        e.target.button_bg === undefined
          ? agency?.Customization?.button_bg
          : e.target.button_bg.value,
      button_text:
        e.target.button_text === undefined
          ? agency?.Customization?.button_text
          : e.target.button_text.value,
      button_border:
        e.target.button_border === undefined
          ? agency?.Customization?.button_border
          : e.target.button_border.value,
      setting_btn_bg:
        e.target.setting_btn_bg === undefined
          ? agency?.Customization?.setting_btn_bg
          : e.target.setting_btn_bg.value,
      setting_btn_hover_bg:
        e.target.setting_btn_hover_bg === undefined
          ? agency?.Customization?.setting_btn_hover_bg
          : e.target.setting_btn_hover_bg.value,
      setting_btn_text:
        e.target.setting_btn_text === undefined
          ? agency?.Customization?.setting_btn_text
          : e.target.setting_btn_text.value,
      newsfeed_bg:
        e.target.newsfeed_bg === undefined
          ? agency?.Customization?.newsfeed_bg
          : e.target.newsfeed_bg.value,
      newsfeed_text:
        e.target.newsfeed_text === undefined
          ? agency?.Customization?.newsfeed_text
          : e.target.newsfeed_text.value,
      newsfeed_tag_bg:
        e.target.newsfeed_tag_bg === undefined
          ? agency?.Customization?.newsfeed_tag_bg
          : e.target.newsfeed_tag_bg.value,
      newsfeed_tag_text:
        e.target.newsfeed_tag_text === undefined
          ? agency?.Customization?.newsfeed_tag_text
          : e.target.newsfeed_tag_text.value,
      hero_bg: hero_bg ? hero_bg : agency?.Customization?.hero_bg,
      hero_image: hero_image_url ? hero_image_url : agency?.Customization?.hero_image_url,
      default_image: default_image ? default_image : agency?.Customization?.default_image,
      social_urls: social_urls,
      customer_info: customer_info,
      custom_color: custom_color ? custom_color : agency?.Customization?.custom_color,
      logo: logo ? logo : agency?.Customization?.logo,
      chatapp_logo: chatapp_logo ? chatapp_logo : agency?.Customization?.chatapp_logo,
      chatapp_text:
        e.target.chatapp_text === undefined
          ? agency?.Customization?.chatapp_text
          : e.target.chatapp_text.value,
      ghl_connect_logo: ghl_connect_logo
        ? ghl_connect_logo
        : agency?.Customization?.ghl_connect_logo,
      ghl_connect_heading:
        e.target.ghl_connect_heading === undefined
          ? agency?.Customization?.ghl_connect_heading
          : e.target.ghl_connect_heading.value,
      ghl_connect_sub_heading:
        e.target.ghl_connect_sub_heading === undefined
          ? agency?.Customization?.ghl_connect_sub_heading
          : e.target.ghl_connect_sub_heading.value,
      whitelabel_logo: whitelabel_logo ? whitelabel_logo : agency?.Customization?.whitelabel_logo,
      whitelabel_text:
        e.target.whitelabel_text === undefined
          ? agency?.Customization?.whitelabel_text
          : e.target.whitelabel_text.value,
      copyicon_text:
        e.target.copyicon_text === undefined
          ? agency?.Customization?.copyicon_text
          : e.target.copyicon_text.value,
      brainicon_text:
        e.target.brainicon_text === undefined
          ? agency?.Customization?.brainicon_text
          : e.target.brainicon_text.value,
      uploadicone_text:
        e.target.uploadicone_text === undefined
          ? agency?.Customization?.uploadicone_text
          : e.target.uploadicone_text.value,
      home_m_title:
        e.target.home_m_title === undefined
          ? agency?.Customization?.home_m_title
          : e.target.home_m_title.value,
      home_m_description:
        e.target.home_m_description === undefined
          ? agency?.Customization?.home_m_description
          : e.target.home_m_description.value,
      chat_m_title:
        e.target.chat_m_title === undefined
          ? agency?.Customization?.chat_m_title
          : e.target.chat_m_title.value,
      chat_m_description:
        e.target.chat_m_description === undefined
          ? agency?.Customization?.chat_m_description
          : e.target.chat_m_description.value,
      celender_m_title:
        e.target.celender_m_title === undefined
          ? agency?.Customization?.celender_m_title
          : e.target.celender_m_title.value,
      celender_m_description:
        e.target.celender_m_description === undefined
          ? agency?.Customization?.celender_m_description
          : e.target.celender_m_description.value,
      setting_m_title:
        e.target.setting_m_title === undefined
          ? agency?.Customization?.setting_m_title
          : e.target.setting_m_title.value,
      setting_m_description:
        e.target.setting_m_description === undefined
          ? agency?.Customization?.setting_m_description
          : e.target.setting_m_description.value,
      newsfeedshow: newsfeedshow === undefined ? agency?.Customization?.newsfeedshow : newsfeedshow,
      video_text: video_text === undefined ? agency?.Customization?.video_text : video_text,
      video_link: video_link === undefined ? agency?.Customization?.video_link : video_link,
      gtag: e.target.gtag === undefined ? agency?.Customization?.gtag : e.target.gtag.value,
    };

    const payload = {
      _id: agency._id,
      domainUpdate: domain_update,
      domain: e.target?.domain?.value || agency?.domain,
      Customization: customization,
      Categories: updatedCategories,
      pricing_page_message: pricing_page_message,
      keyBenefits: keyBenefits,
      pricing_page_headline: pricing_page_headline,
      upgrade_benefits: upgrade_benefits,
      train_your_ai: train_your_ai,
    };

    console.log(payload, "bilal payload");

    // return true;
    try {
      const { response } = await saveSettingsMutation.mutateAsync(payload);
      if (response) {
        Update(response.data);
      }
    } catch (error) {
      console.log("An error occurred");
    } finally {
      setLoading(false);
      // Set loading to false once the request is complete
    }
  };
  const onLoad = () => {
    var temp_time = [];
    for (let index = 0; index < timezones.length; index++) {
      const element = timezones[index];

      var temp = {
        label: element.text,
        value: element.value,
      };
      temp_time.push(temp);
    }
    settimezones_data(temp_time);
  };
  useEffect(() => {
    onLoad();
  }, []);

  return (
    <PageLayout>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <SoftBox mb={3} marginRight="1em">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <BasicInfo
                  handleImage={handleImage}
                  handleSubmit={handleSubmit}
                  loading={loading}
                  setbussiness_name={setbussiness_name}
                  bussiness_name={bussiness_name}
                  timezones_data={timezones_data}
                  categories={categories}
                  setCategories={setCategories}
                  setPricingPageMessage={setPricingPageMessage}
                  pricing_page_message={pricing_page_message}
                  keyBenefits={keyBenefits}
                  setKeyBenefits={setKeyBenefits}
                  setPricingPageHeadline={setPricingPageHeadline}
                  pricing_page_headline={pricing_page_headline}
                  upgrade_benefits={upgrade_benefits}
                  setUpgradeBenefits={setUpgradeBenefits}
                  setTrainYourAI={setTrainYourAI}
                  train_your_ai={train_your_ai}
                />
              </Grid>
            </Grid>
          </SoftBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

export default Settings;
